module.exports = __webpack_public_path__ + "static/condo-8-99188228cdc0de1e0bdc348cbdb1489b.jpg";